/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const sessioniAPI = {
  // Tutti i timer aperti, di qualunque tecnico
  attive: async () => { const { data } = await apiClient.get('/sessioni/attive'); return data; },
  // Scarta un timer: la sessione viene eliminata e le ore non vengono conteggiate
  annulla: async (sessione_id, motivo) => {
    const { data } = await apiClient.post('/sessioni/annulla', { sessione_id, motivo: motivo || null });
    return data;
  },
  // Chiude il timer di un tecnico: le ore vengono conteggiate
  termina: async (sessione_id, { fine, pausa_minuti, motivo }) => {
    const { data } = await apiClient.post('/sessioni/termina', { sessione_id, fine, pausa_minuti, motivo });
    return data;
  },
  // Corregge una sessione gia' chiusa
  modifica: async (sessione_id, { inizio, fine, pausa_minuti, note, motivo }) => {
    const { data } = await apiClient.patch(`/sessioni/${sessione_id}`, { inizio, fine, pausa_minuti, note, motivo });
    return data;
  },
};
